import type { AIChatErrorType } from '@store/reducers/ai/types'
import axios, { type AxiosError } from 'axios'

import { TASK_COMPLETION_TIMEOUT_ERROR_MESSAGE } from './constants'
import type { AiTaskConflictResponse } from './types'

export const isTaskInProgressError = (
  error: unknown
): error is AxiosError<AiTaskConflictResponse> =>
  axios.isAxiosError(error) && error.response?.status === 409

export const isLimitReachedError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 403

export const createTaskCompletionTimeoutError = (): Error =>
  new Error(TASK_COMPLETION_TIMEOUT_ERROR_MESSAGE)

const isTimeoutError = (error: unknown): boolean =>
  (axios.isAxiosError(error) &&
    (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')) ||
  (error instanceof Error &&
    error.message === TASK_COMPLETION_TIMEOUT_ERROR_MESSAGE)

export const classifyAIChatError = (error: unknown): AIChatErrorType => {
  if (isTaskInProgressError(error)) {
    return 'task_in_progress'
  }

  if (isTimeoutError(error)) {
    return 'timeout'
  }

  return 'unknown'
}
